export const megaMinderStatus = {
  OK: {
    error: false,
    continue: true,
  },
  KO: {
    error: true,
    errorInfo: null,
    continue: false,
  },
  RECOVERABLE_ERROR: {
    error: true,
    errorInfo: null,
    continue: true,
  },
  LOGICAL_ERROR: {
    error: true,
    continue: false,
  },
};
